import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

const Navbar = () => {
  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/");
    } catch (error) {
      alert("Error logging out: " + error.message);
    }
  };

  const linkStyle = {
    padding: "10px 18px",
    margin: "0 6px",
    textDecoration: "none",
    color: "#333",
    borderRadius: "8px",
    transition: "all 0.2s ease",
    fontWeight: "500",
  };

  return (
    <nav
      style={{
        backgroundColor: "#fff",
        padding: "12px 24px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      {/* 🧠 App Logo / Title */}
      <div style={{ fontWeight: "700", fontSize: "20px", color: "#0066cc" }}>
        CreatorFlow
      </div>

      {/* 🔗 Navigation Links */}
      <div>
        {[
          { to: "/dashboard", label: "Home" },
          { to: "/ideas", label: "Ideas" },
          { to: "/suggestions", label: "Suggestions" },
          { to: "/reminders", label: "Reminders" },
          { to: "/calendar", label: "Calendar" },
          { to: "/settings", label: "Settings" },
        ].map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            style={({ isActive }) => ({
              ...linkStyle,
              backgroundColor: isActive ? "#e6f0ff" : "transparent",
              color: isActive ? "#0066cc" : "#333",
              boxShadow: isActive ? "0 0 6px rgba(0,102,204,0.2)" : "none",
            })}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#f2f2f2";
            }}
            onMouseLeave={(e) => {
              if (!e.target.classList.contains("active")) {
                e.target.style.backgroundColor = "transparent";
              }
            }}
          >
            {link.label}
          </NavLink>
        ))}
      </div>

      {/* 🚪 Logout Button */}
      <button
        onClick={handleLogout}
        style={{
          backgroundColor: "#ff4d4d",
          color: "white",
          border: "none",
          padding: "8px 14px",
          borderRadius: "6px",
          cursor: "pointer",
          fontWeight: "500",
          transition: "all 0.2s ease",
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = "#e63939")}
        onMouseLeave={(e) => (e.target.style.backgroundColor = "#ff4d4d")}
      >
        Logout
      </button>
    </nav>
  );
};

export default Navbar;
